import AppFormInput from '../../../../../../components/ui/AppFormInput';
import AppFormSelect from '../../../../../../components/ui/AppFormSelect';
import React, {useState} from "react";
import {BlockUI} from 'primereact/blockui';
import apiClient from "../../../../../../services/api-client";
import {Calendar} from "primereact/calendar";
import {useMountEffect} from 'primereact/hooks';
import StorageHelper from '../../../../../../utils/storage-helper';
import PhoneNumberInput from "../../../../../../components/common/PhoneNumberInput";

function convertDOBToCAT(dobString) {
  // Parse the DOB string into a Date object
  const dobDate = new Date(dobString);

  // Create a CAT (Central Africa Time) Date object
  const catDate = new Date(dobDate);
  catDate.setUTCHours(catDate.getUTCHours() + 2);

  return catDate;
}

function formatDateToDDMMYYYY(inputDate) {
  const date = new Date(inputDate);
  
  if (Number.isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

function calculateAge(dateOfBirth) {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

function generateInitials(firstName, surname) {
  const firstInitial = firstName.charAt(0).toUpperCase();
  const surnameInitial = surname.charAt(0).toUpperCase();
  return firstInitial + surnameInitial;
}

const PrincipalMemberForm = ({ moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput, titles, toast }) => {
  const [firstName, setFirstName] = useState("");
  const [otherNames, setOtherNames] = useState("");
  const [surname, setSurname] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [dob, setDob] = useState("");
  const [title, setTitle] = useState("");
  const [gender, setGender] = useState("");
  const [mStatus, setMStatus] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [altPhoneNumber, setAltPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [region, setRegion] = useState("");
  const [nationality, setNationality] = useState('');
  const [formErrors, setFormErrors] = useState({});

  const [loading, setLoading] = useState(false);
  const genderOptions = [
    {
      name: 'Male',
      value: 'MALE'
    },
    {
      name: 'Female',
      value: 'FEMALE'
    },
  ]

  const nationalityOptions = [
    {
      name: 'Zimbabwean',
      value: 'ZIMBABWEAN'
    },
    {
      name: 'South African',
      value: 'SOUTH AFRICAN'
    },
    {
      name: 'Namibian',
      value: 'NAMIBIAN'
    },
    {
      name: 'Botswanan',
      value: 'BOTSWANAN'
    },
    {
      name: 'Zambian',
      value: 'ZAMBIAN'
    },
    {
      name: 'Mozambican',
      value: 'MOZAMBICAN'
    },
    {
      name: 'Swazi',
      value: 'SWAZI'
    },
    {
      name: 'Lesotho',
      value: 'LESOTHO'
    },
    {
      name: 'Malawian',
      value: 'MALAWIAN'
    },
  ];  


  const fetchFromUser = () => {
    const userProfileData = StorageHelper.get("userProfile");
    if (!userProfileData) {
      return;
    }

    try {
      // Handle both stringified JSON and raw objects safely
      const decodedData = typeof userProfileData === 'string' ? JSON.parse(userProfileData) : userProfileData;

      // First truthy value among the keys the profile may use for a field
      const pick = (...keys) => keys.map((key) => decodedData[key]).find(Boolean);

      const fields = [
        [setFirstName, pick('firstName')],
        [setSurname, pick('lastName', 'surname')],
        [setEmail, pick('emailAddress', 'email')],
        [setPhoneNumber, pick('phoneNumber', 'phone')],
        [setIdNumber, pick('idnumber', 'idNumber')],
        [setGender, pick('gender')?.toUpperCase()],
        [setAddress, pick('address')],
        [setRegion, pick('region', 'province')],
      ];
      fields.forEach(([setter, value]) => {
        if (value) setter(value);
      });

      // Also populate dob if available
      const rawDob = pick('dateOfBirth', 'dob');
      if (rawDob) {
        const parsedDob = new Date(rawDob);
        if (!Number.isNaN(parsedDob.getTime())) setDob(parsedDob);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }

  useMountEffect(() => {
    fetchFromUser()
    populateForExisting()
});




function populateForExisting() {
  if(userPolicyInput.mainMember != null){
    setFirstName(userPolicyInput.mainMember.First_Name)
    setAddress(userPolicyInput.mainMember.Address)
    setNationality(userPolicyInput.mainMember.Region)
    setSurname(userPolicyInput.mainMember.Surname)
    setDob(convertDOBToCAT(userPolicyInput.mainMember.Date_Of_Birth))
    setGender(userPolicyInput.mainMember.Gender)
    setTitle(userPolicyInput.mainMember.Title)
    setMStatus(userPolicyInput.mainMember.Marital_Status)
    setAltPhoneNumber(userPolicyInput.mainMember.Home_Tel)
    //console.log(userPolicyInput.mainMember.Date_Of_Birth)

    // nationalityOptions
  }
}
  const titleOptions = [
    {
      name: 'Mr',
      value: 'MR'
    },
    {
      name: 'Mrs',
      value: 'MRS'
    },
    {
      name: 'Miss',
      value: 'MISS'
    },
    {
      name: 'Ms',
      value: 'MS'
    },
    {
      name: 'Dr',
      value: 'DR'
    },
    {
      name: 'Prof',
      value: 'PROF'
    },
    {
      name: 'Rev',
      value: 'REV'
    }
  ];

  


  const maritalStatusOptions = [
    {
      name: 'Single',
      value: 'SINGLE'
    },
    {
      name: 'Married',
      value: 'MARRIED'
    },
    {
      name: 'Divorced',
      value: 'DIVORCED'
    },
    {
      name: 'Widowed',
      value: 'WIDOWED'
    },
    {
      name: 'Separated',
      value: 'SEPARATED'
    }
  ];


  function handleSubmit(e) {
    e.preventDefault();
    
    const errors = formValidation();

    if (Object.keys(errors).length === 0) {
      setFormErrors({});
      moveToNext()
      
    } else {
      setFormErrors(errors);
    }
  }

  const moveToNext = () => {
    

    let mainMember ={
      firstName: firstName,
      surname: surname,
      idNumber: idNumber,
      dob: formatDateToDDMMYYYY(dob),
      title: title,
      ID_Number: idNumber,
      ProductId: userPolicyInput.selectedProductId,
      First_Name: firstName,
      Initials: generateInitials(firstName, surname),
      Title: title,
      Surname: surname,
      Date_Of_Birth: formatDateToDDMMYYYY(dob),
      Region: nationality,
      Gender: gender,
      Marital_Status: mStatus,
      Address: address,
      PostalAddress: address,
      Home_Tel: phoneNumber,
      Work_Tel: phoneNumber,
      Cell_Number: phoneNumber,
      EmailAddress: email,
      MMAge: calculateAge(dob),
      SourceOfWealth: "Employment",
      SourceOfFunds: "Employment",
      ExtendedPlanID: userPolicyInput.selectedProductId,
      ExtendedPlanCover: 0,
      Nationality: nationality

    }

    //console.log(mainMember);

    const payload = {
      "operation": "createPolicyApplicationStage1",
      "requestBody": {
        "planId": userPolicyInput.selectedPlanName,
        "planName": userPolicyInput.selectedPlanID,
        "productId": userPolicyInput.selectedProductId,
        "groupId": userPolicyInput.selectedSubGroupPlan.easipolPolicySubGroup.SubGroupID,
        "productName": userPolicyInput.selectedProductName,
        "applicationTotalStages": 3,
        "currentStages": 1,
        "applicationType": userPolicyInput.selectedPlanType,
        "mainMember": mainMember
      }
    }
   
    setuserPolicyInput({ ...userPolicyInput, mainMember: mainMember, mainMemberName: mainMember.firstName });
    submitStage1toServer(payload);

  }

  const formValidation = ()=>{
    const errors = {}
    if (!firstName.trim()) {
      errors.firstName = 'First name is required';
    }
  
    // if (!otherNames.trim()) {
    //   errors.otherNames = 'Other names are required';
    // }
  
    if (!surname.trim()) {
      errors.surname = 'Surname is required';
    }
  
    if (!idNumber.trim()) {
      errors.idNumber = 'ID number is required';
    }

    if (!title.trim()) {
      errors.title = 'Select your title';
    }

    if (!gender.trim()) {
      errors.gender = 'Select your gender';
    }

    if (!mStatus.trim()) {
      errors.mStatus = 'Select your marital status';
    }

    if (!dob) {
      errors.dob = 'Select your date of birth';
    }

    if (!phoneNumber.trim()) {
      errors.phoneNumber = 'Phone number is required';
    }

    if (!address.trim()) {
      errors.address = 'Address is required';
    }

    if (!nationality.trim()) {
      errors.nationality = 'Select your nationality';
    }

    return errors
  }
  function validateDateOfBirth(value) {
    
    const applicantAge = calculateAge(value)
    
    if( applicantAge < Number(userPolicyInput.selectedProduct.AgeFrom) ||  applicantAge > Number(userPolicyInput.selectedProduct.AgeTo) ){

      let errors = formValidation();

      errors.dob = "Date out of range: Your age should between "+ userPolicyInput.selectedProduct.AgeFrom +" and "+ userPolicyInput.selectedProduct.AgeTo +"."

      setFormErrors(errors);

    }
    else{
      setDob(value)
    }

    
  }

  

  const showToastMessage = (title, message, messageType) => {
    toast.current.show({ severity: messageType, summary: title, detail: message, life: 15000 });
  }





  const submitStage1toServer = async (payload) => {
    setLoading(true);
    //console.log(payload);
    await apiClient.post('policy/apply/1', payload,{
      headers: {
        Authorization: 'Bearer ' + (StorageHelper.get('token'))
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        //console.log(response.data.responseBody)
        showToastMessage("Progress Saved", firstName + " your progress has been saved", "success");
        moveToNextView();
      }
      else {
        setLoading(false);
        showToastMessage("Failed to save your progress", response.data.message, "warn");
      }
    }).catch((e) => {
      setLoading(false);
      //console.log(e)
    })


  }



  return (
    <div className="w-full max-w-5xl mx-auto mb-12">
      <BlockUI blocked={loading}>
        <div className="card bg-base-100 shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-base-200/60 overflow-hidden rounded-2xl">
            <div className="bg-base-200/50 px-8 py-6 border-b border-base-200">
                <h3 className="text-2xl font-bold text-base-content mb-1">Fill in Principal Member details</h3>
                <p className="text-base-content/70 text-sm">Please provide the principal member's personal information.</p>
            </div>
            
            <form onSubmit={handleSubmit} className="p-8">
              <h4 className="font-bold text-lg text-primary border-b border-base-200 pb-2 mb-6">BASIC INFORMATION</h4>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
                
                <AppFormSelect 
                    containerClassName="col-span-1 mb-4"
                    id="title"
                    label="Title"
                    placeholder="Select title"
                    value={title}
                    options={titleOptions}
                    onChange={(e) => setTitle(e.target.value)}
                    error={formErrors.title}
                />

                <AppFormSelect 
                    containerClassName="col-span-1 mb-4"
                    id="gender"
                    label="Gender"
                    placeholder="Select gender"
                    value={gender}
                    options={genderOptions}
                    onChange={(e) => setGender(e.target.value)}
                    error={formErrors.gender}
                />

                <AppFormSelect 
                    containerClassName="col-span-1 mb-4"
                    id="mStatus"
                    label="Marital Status"
                    placeholder="Select marital status"
                    value={mStatus}
                    options={maritalStatusOptions}
                    onChange={(e) => setMStatus(e.target.value)}
                    error={formErrors.mStatus}
                />

                <AppFormInput
                    containerClassName="col-span-1 mb-4"
                    label="First Name"
                    id="firstName"
                    placeholder="Enter your first name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    error={formErrors.firstName}
                />
                
                <AppFormInput
                    containerClassName="col-span-1 mb-4"
                    label="Other names"
                    id="otherNames"
                    placeholder="Enter your other names"
                    value={otherNames}
                    onChange={(e) => setOtherNames(e.target.value)}
                    error={formErrors.otherNames}
                />

                <AppFormInput
                    containerClassName="col-span-1 mb-4"
                    label="Surname"
                    id="surname"
                    placeholder="Enter your surname"
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                    error={formErrors.surname}
                />

                <AppFormInput
                    containerClassName="col-span-1 mb-4"
                    label="National ID Number"
                    id="idNumber"
                    required
                    placeholder="Enter your national ID"
                    value={idNumber}
                    onChange={(e) => setIdNumber(e.target.value)}
                    error={formErrors.idNumber}
                />


                <AppFormSelect
                    containerClassName="col-span-1 mb-4"
                    id="nationality"
                    label="Nationality"
                    placeholder="Select nationality"
                    value={nationality}
                    options={nationalityOptions}
                    onChange={(e) => setNationality(e.target.value)}
                    error={formErrors.nationality}
                />

                <div className="col-span-1 mb-4">
                  <label htmlFor="birth_date_input" className="label py-1"><span className="label-text text-xs font-bold text-slate-700">Birth Date</span></label>
                  <Calendar
                    inputId="birth_date_input"
                    showIcon
                    className="w-full flex items-center bg-white border border-slate-300 focus-within:border-[#135A9C] focus-within:ring-2 focus-within:ring-[#135A9C]/20 rounded-xl overflow-hidden h-12"
                    id="birth_date"
                    placeholder="Select Date of birth"
                    value={dob}
                    onChange={(e) => {
                        if (e.target.value !== null) {
                            setDob(e.target.value);
                            validateDateOfBirth(e.target.value);
                        }
                    }}
                    prevIcon="pi pi-chevron-left"
                    nextIcon="pi pi-chevron-right"
                  />
                  {formErrors.dob && <p className="text-error text-xs mt-1">{formErrors.dob}</p>}
                </div>
              </div>

              <h4 className="font-bold text-lg text-primary border-b border-base-200 pb-2 mb-6 mt-8">CONTACT DETAILS</h4>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
                <PhoneNumberInput
                    label="Phone Number"
                    defaultCountry="zw"
                    value={phoneNumber}
                    onChange={(val) => setPhoneNumber(val)}
                    placeholder="712 345 678"
                />

                <PhoneNumberInput
                    containerClassName="col-span-1 mb-4"
                    label="Alternative Phone Number"
                    id="altPhoneNumber"
                    placeholder="Alternative Phone number"
                    name="altPhoneNumber"
                    value={altPhoneNumber}
                    onChange={(val) => setAltPhoneNumber(val)}
                    error={formErrors.altPhoneNumber}
                />

                <AppFormInput
                    containerClassName="col-span-1 mb-4"
                    label="Email Address"
                    id="email"
                    placeholder="Email address"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={formErrors.email}
                />

                <AppFormInput
                    containerClassName="col-span-1 lg:col-span-2 mb-4"
                    label="Physical Address"
                    id="address"
                    placeholder="Enter your address"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    error={formErrors.address}
                />

                <AppFormInput
                    containerClassName="col-span-1 mb-4"
                    label="Region / Province"
                    id="region"
                    placeholder="Enter your region"
                    name="region"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    error={formErrors.region}
                />
              </div>

              <div className="card-actions justify-end mt-10 pt-6 border-t border-base-200/50">
                <button 
                  type="submit" 
                  className="btn btn-primary rounded-full px-12 shadow-md hover:shadow-lg transition-all font-bold tracking-wide text-white"
                >
                  Continue <i className="pi pi-arrow-right ml-2 text-sm"></i>
                </button>
              </div>
            </form>
        </div>
      </BlockUI>
    </div>
  );
};

export default PrincipalMemberForm;
